<script setup lang="ts">
import {Award, Building2, ShieldCheck} from 'lucide-vue-next';
import SectionHeading from '../components/SectionHeading.vue';
import {useLanguage} from '../composables/useLanguage';

const {isArabic} = useLanguage();

const cards = [
  {
    icon: Building2,
    titleAr: 'من نحن',
    titleEn: 'Who we are',
    textAr: 'شركة القَصواء الكبرى تقدم خدمات المقاولات العامة والاستثمار العقاري بمزيج من الخبرة المحلية والانضباط التشغيلي.',
    textEn: 'ALQASWA ALKOBRA delivers general contracting and real estate investment with local expertise and disciplined execution.',
  },
  {
    icon: ShieldCheck,
    titleAr: 'ما الذي نفعله',
    titleEn: 'What we do',
    textAr: 'ننفذ المشاريع السكنية والتجارية والبنية التحتية مع متابعة الجودة والسلامة في كل مرحلة.',
    textEn: 'We execute residential, commercial, and infrastructure projects with quality and safety oversight at every stage.',
  },
  {
    icon: Award,
    titleAr: 'لماذا نحن',
    titleEn: 'Why us',
    textAr: 'نهتم بالتسليم في الوقت، والشفافية، والنتائج التي تبني الثقة على المدى الطويل.',
    textEn: 'We focus on on-time delivery, transparency, and results that build long-term trust.',
  },
];
</script>

<template>
  <section class="page-shell">
    <div class="container page-hero">
      <SectionHeading
        align="start"
        :eyebrow="isArabic ? 'من نحن' : 'About us'"
        :title="isArabic ? 'نقود المشاريع بروح الشريك لا مجرد المنفذ' : 'We lead projects as a partner, not just a contractor'"
        :description="isArabic
          ? 'نجمع بين التخطيط الواضح والتنفيذ المنضبط والخبرة المحلية لنقدّم قيمة عملية ومستدامة.'
          : 'We combine clear planning, disciplined delivery, and local expertise to create practical, lasting value.'"
      />
    </div>
    <div class="container page-grid page-grid--cards">
      <article v-for="card in cards" :key="card.titleEn" class="page-card reveal">
        <span class="page-card__icon"><component :is="card.icon" :size="28" /></span>
        <h3>{{ isArabic ? card.titleAr : card.titleEn }}</h3>
        <p>{{ isArabic ? card.textAr : card.textEn }}</p>
      </article>
    </div>
  </section>
</template>
